import { Injectable } from '@angular/core';

import { STATUS_COLORS } from '@lib/commons/constants/status-colors';

@Injectable({
  providedIn: 'root',
})
export class StatusService<T> {
  protected statusColors = STATUS_COLORS;

  getColor(status: keyof T): string {
    return this.statusColors[status as keyof typeof STATUS_COLORS] || 'bg-neutral-100';
  }
}
